<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre11" id="pgepubid00005">CONTENTS</h2>
<table border="0" cellpadding="5" cellspacing="0" class="calibre12" summary="Contents">
<colgroup class="calibre13"><col class="calibre14"/>
<col class="calibre15"/>
<col class="calibre14"/>
</colgroup>
<tbody class="calibre16"><tr class="calibre17">
<th class="smfontr">CHAPTER</th>
<th class="tdl"></th>
<th class="smfontr">PAGE</th>
</tr>
<tr class="calibre17">
<td class="tdrt">I.</td>
<td class="tdl1"><a href="#/Text/Section0007#I">Kit Carson to the Rescue</a></td>
<td class="tdrb">17</td>
</tr>
<tr class="calibre17">
<td class="tdrt">II.</td>
<td class="tdl1"><a href="#/Text/Section0008#II">Under the Wagon</a></td>
<td class="tdrb">30</td>
</tr>
<tr class="calibre17">
<td class="tdrt">III.</td>
<td class="tdl1"><a href="#/Text/Section0009#III">Oliver Wins His Spurs</a></td>
<td class="tdrb">43</td>
</tr>
<tr class="calibre17">
<td class="tdrt">IV.</td>
<td class="tdl1"><span href="#/Text/Section0010#IV" title="Link target outside of Sample">Word from Old Fort Laramie</span></td>
<td class="tdrb">56</td>
</tr>
<tr class="calibre17">
<td class="tdrt">V.</td>
<td class="tdl1"><span href="#/Text/Section0011#V" title="Link target outside of Sample">Frémont Says “Onward!”</span></td>
<td class="tdrb">68</td>
</tr>
<tr class="calibre17">
<td class="tdrt">VI.</td>
<td class="tdl1"><span href="#/Text/Section0012#VI" title="Link target outside of Sample">Into the Wilder West</span></td>
<td class="tdrb">87</td>
</tr>
<tr class="calibre17">
<td class="tdrt">VII.</td>
<td class="tdl1"><span href="#/Text/Section0013#VII" title="Link target outside of Sample">Over the Famed South Pass</span></td>
<td class="tdrb">96</td>
</tr>
<tr class="calibre17">
<td class="tdrt">VIII.</td>
<td class="tdl1"><span href="#/Text/Section0014#VIII" title="Link target outside of Sample">Planting the Highest Flag</span></td>
<td class="tdrb">111</td>
</tr>
<tr class="calibre17">
<td class="tdrt">IX.</td>
<td class="tdl1"><span href="#/Text/Section0015#IX" title="Link target outside of Sample">The Voyaging of the Platte</span></td>
<td class="tdrb">124</td>
</tr>
<tr class="calibre17">
<td class="tdrt">X.</td>
<td class="tdl1"><span href="#/Text/Section0016#X" title="Link target outside of Sample">Frémont Calls Again</span></td>
<td class="tdrb">135</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XI.</td>
<td class="tdl1"><span href="#/Text/Section0017#XI" title="Link target outside of Sample">In Hostile Territory</span></td>
<td class="tdrb">147</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XII.</td>
<td class="tdl1"><span href="#/Text/Section0018#XII" title="Link target outside of Sample">The Emigrant Trail</span></td>
<td class="tdrb">155</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XIII.</td>
<td class="tdl1"><span href="#/Text/Section0019#XIII" title="Link target outside of Sample">To the Great Salty Lake</span></td>
<td class="tdrb">167</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XIV.</td>
<td class="tdl1"><span href="#/Text/Section0020#XIV" title="Link target outside of Sample">Sailing the Inland Sea</span></td>
<td class="tdrb">178</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XV.</td>
<td class="tdl1"><span href="#/Text/Section0021#XV" title="Link target outside of Sample">On to the Columbia</span></td>
<td class="tdrb">192</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XVI.</td>
<td class="tdl1"><span href="#/Text/Section0022#XVI" title="Link target outside of Sample">Southward for the Unknown</span></td>
<td class="tdrb">203</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XVII.</td>
<td class="tdl1"><span href="#/Text/Section0023#XVII" title="Link target outside of Sample">Scant Christmas Comfort</span></td>
<td class="tdrb">216</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XVIII.</td>
<td class="tdl1"><span href="#/Text/Section0024#XVIII" title="Link target outside of Sample">Forcing the Snowy Sierras</span></td>
<td class="tdrb">225</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XIX.</td>
<td class="tdl1"><span href="#/Text/Section0025#XIX" title="Link target outside of Sample">At the Last Gasp</span></td>
<td class="tdrb">235</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XX.</td>
<td class="tdl1"><span href="#/Text/Section0026#XX" title="Link target outside of Sample">Down Through California</span></td>
<td class="tdrb">248</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XXI.</td>
<td class="tdl1"><span href="#/Text/Section0027#XXI" title="Link target outside of Sample">The Vengeance of Kit Carson</span></td>
<td class="tdrb">259</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XXII.</td>
<td class="tdl1"><span href="#/Text/Section0028#XXII" title="Link target outside of Sample">Poor Tabeau Pays the Price</span></td>
<td class="tdrb">276</td>
</tr>
<tr class="calibre17">
<td class="tdrt">XXIII.</td>
<td class="tdl1"><span href="#/Text/Section0029#XXIII" title="Link target outside of Sample">The Home Stretch</span></td>
<td class="tdrb">288</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?2a2bd8e2